import profile2Removebg from "../pictures/profile2-removebg.png"
import osint from "../pictures/osint.png"
import redteam from "../pictures/redteam.jpg"
import siem from "../pictures/siem.jpeg"
import ai from "../pictures/ai-spam-detector.png"
import security_architecture from "../pictures/security-architecture.jpg"
import vulnerability_assessment from "../pictures/vulnerability-assessment.jpeg"
import cloud from "../pictures/cloud.png"
import hackthebox from "../pictures/hackthebox.jpg"
import tryhackme from "../pictures/tryhackme.jpg"
import cheatsheets from "../pictures/cheatsheets.png"
import hqphu from "../pictures/hqphu.png"
import hhphu from "../pictures/hhphu.png"

const images = {
    profile2Removebg,
    osint,
    redteam,
    siem,
    ai,
    security_architecture,
    vulnerability_assessment,
    cloud,
    hackthebox,
    tryhackme,
    cheatsheets,
    hqphu,
    hhphu,
}

export default images;
